import { ContractorsBySkills } from '@interfaces/vendor-management-model';

export const columnDefs = [
  {
    field: 'fullName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'projectName',
    headerName: 'Project Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'relevantExp',
    headerName: 'Relevant Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'cbreExpYears',
    headerName: 'CBRE Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'totalExp',
    headerName: 'Total Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'primarySkills',
    headerName: 'Primary Skills',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'secondarySkills',
    headerName: 'Secondary Skills',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
];
